import parse from 'html-react-parser';
import { Component } from 'react';
import QuickReplyList from '../../containers/QuickReplyList';
import DOMService from '../../services/DOMService';
import { sendNavigateToUrl } from '../../services/postMessageService';
import type { Button, MessageWithButtonsData } from '../../types/ChatWindow';
import type { MessageScheme } from '../../types/configs';
import { parseMessageProtocols } from './messageHelper';

class ButtonedTextMessage extends Component<
  {
    data: MessageWithButtonsData;
    scheme: MessageScheme;
    submitHandler: (...args: any[]) => void;
  },
  { buttonClicked: boolean }
> {
  constructor(props: {
    data: MessageWithButtonsData;
    scheme: MessageScheme;
    submitHandler: (...args: any[]) => void;
  }) {
    super(props);
    this.state = {
      buttonClicked: false,
    };
  }

  handleClick = (clickedButton: Button) => {
    const {
      submitHandler,
      data: { llmUsageId },
    } = this.props;
    const submitData = {
      value: clickedButton,
    };

    if (clickedButton.url) {
      sendNavigateToUrl(
        clickedButton.url,
        clickedButton?.options?.webclient?.urlOpenMethod,
      );

      Object.assign(submitData, {
        value: {
          ...submitData.value,
          llmUsageId,
        },
        postbackType: 'buttonClick',
      });
    }

    submitHandler({ ...submitData, shouldHideMessage: true });
  };

  render() {
    const { buttonClicked } = this.state;
    const {
      data: { text, buttons },
      scheme: { messageBubbleColor, messageBubbleTextColor },
      scheme,
    } = this.props;

    const purifiedText = DOMService.purify(text);
    const message = parseMessageProtocols(purifiedText);
    const showText = typeof text === 'string' && text !== '';

    return (
      <>
        {showText && (
          <div
            className='word-break-style message-content'
            style={{
              backgroundColor: messageBubbleColor,
              color: messageBubbleTextColor,
            }}>
            {parse(message)}
          </div>
        )}
        {!buttonClicked && buttons?.length > 0 && (
          <QuickReplyList
            buttons={buttons}
            onClick={this.handleClick}
            scheme={scheme}
          />
        )}
      </>
    );
  }
}

export default ButtonedTextMessage;
